export default __webpack_public_path__ + "static/media/img7.8df80d15.jpg";